export const emoji = {
  lit: '🔥',
  party: '🎉',
  siren: '🚨',
  plug: '🔌',
  arrowUp: '⬆️',
  arrowRight: '➡️',
  arrowLeft: '⬅️',
  arrowDown: '⬇️',
  play: '▶️',
  refresh: '🔄',
  watching: '👀',
  happy: '😃',
  wondering: '🤔',
  inspect: '🧐',
  glasses: '😎',
  wink: '😉',
  facePalm: '🤦‍♂️',
  fistPump: '👊',
  sweet: '🙌',
  peace: '✌️',
  fingersCrossed: '🤞',
  wave: '👋',
  clapping: '👏',
  pointRight: '👉',
  pointLeft: '👈',
  trendingUpChart: '📈',
  trendingDownChart: '📉',
  chart: '📊',
  question: '❓',
  exclamation: '❗',
  star: '⭐',
  redX: '❌',
  greenCheck: '✅',
  greenX: '❎',
  cog: '⚙️',
  search: '🔍',
  voltage: '⚡',
  stopwatch: '⏱️',
  orangeSquare: '🟧',
  greenSquare: '🟩',
  yellowSquare: '🟨',
  blueSquare: '🟦',
  redSquare: '🟥',
};

export const messages = {
  methodRequired: `Method is required`,
  userNameRequired: `Username is required`,
  passwordRequired: `Password is required`,
  providerRequired: `Provider is required`,
  invalidUsernamePassword: `Invalid username/password`,
  connectionStarted: `${emoji.lit} The connection has been started`,
  connectionStartFailed: `${emoji.siren} An error trying to start the connection`,
  connectionClosing: `${emoji.watching} The connection is going to close`,
  connectionReconnecting: `${emoji.watching} The connection is going to reconnect`,
  connectionReconnected: `${emoji.watching} The connection has been reconnected`,
  connectionEstablished: `${emoji.plug} Socket connection established`,
  invocationFailed: `${emoji.arrowUp} ${emoji.siren} Failed to invoke an engine message`,
  disconnectAttempt: `${emoji.fingersCrossed} Will attempt to disconnect`,
  disconnectAborted: `Disconnect called, but we have a connection already, so we will abort the disconnect attempt 🙌'`,
  disconnectSucceeded: `${emoji.wave} The connection has been stopped`,
  disconnectFailed: `${emoji.siren} The connection failed to stop`,
  apiRequestFailed: `${emoji.siren} API request failed`,
  engineMessageReceived: `${emoji.refresh} Engine emit received`,
};
